import Home from "../components/Home.vue";
import LandingPage from "../components/LandingPage.vue"
import { createRouter, createWebHistory } from "vue-router";
import SingleCaseComponentWrapper from "../components/SingleCaseComponentWrapper.vue";
import NewCaseComponentWrapper from "../components/NewCaseComponentWrapper.vue";
import AuthHelper from "../components/AuthHelper.vue";
import PdfComponent from "../components/PdfComponent.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: Home,
    },
    {
      path: '/index.html',
      component: Home,
    },
    {
      path: "/home",
      component: LandingPage,
    },
    {
      path: "/patient/:id",
      component: SingleCaseComponentWrapper,
    },
    {
      path: '/new-patient',
      component: NewCaseComponentWrapper,
    },
    {
      path: "/jwt-auth",
      component: AuthHelper,
    },
    {
      path: "/report/:caseId",
      component: PdfComponent
    },
  ],
});

export default router;
